import css from 'styled-jsx/css';
import Theme, { colors, fontSizes } from '../../../themes';

const { borderRadius } = Theme.global;

export default css`
  .snippet {
    background: transparent;
    display: block;
    padding: 7px 7px 11px 37%;
  }

  h2 {
    color: ${colors.grayDeep};
    font-size: ${fontSizes.normal};
    font-weight: bold;
    line-height: 1.15;
    margin: 0 0 10px;
    max-height: 38px;
    overflow: hidden;
  }

  .snippet.visited h2 {
    color: ${colors.purpleLight};
  }

  .noPrice {
    font-size: ${fontSizes.normal};
    margin: 5px 0;
  }

  .date {
    font-size: ${fontSizes.small};
    margin: 0 0 5px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }

  .date::first-letter {
    text-transform: capitalize;
  }

  .snippet :global(.img) {
    border-radius: 1px;
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 34%;
  }

  .snippet :global(.photos) {
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    border-radius: ${borderRadius};
    font-size: ${fontSizes.small};
    padding: 4px 6px;
    position: absolute;
    left: 5px;
    bottom: 5px;
  }

  .snippet :global(.new) {
    background: ${colors.orange};
    top: 0;
    color: #fff;
    font-size: ${fontSizes.verySmall};
    padding: 3px 7px 4px;
    position: absolute;
    right: 0;
    text-transform: uppercase;
    margin: 0;
  }

  .snippet :global(.sponsored) {
    background: ${colors.greenOlive};
    top: 0;
    color: #fff;
    font-size: ${fontSizes.verySmall};
    padding: 3px 7px 4px;
    position: absolute;
    right: 0;
    text-transform: uppercase;
    margin: 0;
  }

  .snippet .source-label {
    color: ${colors.blue};
    margin-left: 5px;
  }

  :global(.rtl) .snippet :global(.new) {
    left: 0;
    right: auto;
  }

  :global(.rtl) .snippet :global(.sponsored) {
    left: 0;
    right: auto;
  }

  :global(.rtl) .snippet {
    padding: 7px 35% 7px 11px;
  }

  :global(.rtl) .snippet :global(.img) {
    left: auto;
    right: 0;
  }

  :global(.rtl) .snippet :global(.photos) {
    left: auto;
    right: 5px;
  }

  :global(.rtl) .snippet :global(.photos svg) {
    margin-right: 0;
    margin-left: 4px;
  }

  @media (max-width: 320px) {
    .snippet {
      padding-left: 130px;
    }

    :global(.rtl) .snippet {
      padding-right: 130px;
    }

    .snippet :global(.img) {
      width: 120px;
    }
  }
`;



// WEBPACK FOOTER //
// ./app/common/Snippet/cars/styles.js